import request from '../common'


// 获取城市列表
export function wxLogin (params) {
  return request({
    url: '/wx/login',
    method: 'get',
    params
  })
}

export function getInfo (params) {
  return request({
    url: '/sso/info?noLoading',
    method: 'get',
    params
  })
}

export function getReward () {
  return request({
    url: '/reward',
    method: 'get'
  })
}

export function getInviteReward (params) {
  return request({
    url: '/reward/invite',
    method: 'get',
    params
  })
}

export function getRewardList (params) {
  return request({
    url: '/reward/reward',
    method: 'get',
    params
  })
}

export function feedBack (data) {
  return request({
    url: '/feedBack',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/my.js